import { Component, OnInit } from '@angular/core';
import { ProductSheetService } from '../service/product-sheet.service';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-product-ready',
  templateUrl: './product-ready.component.html',
  styleUrls: ['./product-ready.component.scss']
})
export class ProductReadyComponent implements OnInit {

  public product: any;
  public sku: string;

  constructor(private productSheetService: ProductSheetService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.sku = this.route.snapshot.paramMap.get('sku');
    this.productSheetService.getProduct(this.sku).subscribe((product) => {
      this.product = product;
    });
  }

}
